import React from 'react';

export function FeatureSection({ id, title, subtitle, description, description2, align = 'left', children }) {
  const content = (
    <div className="flex flex-col gap-6 z-10 w-full lg:w-1/2">
      <div>
        <h2 className="text-sm md:text-md font-bold tracking-widest text-[#1c1c1c] mb-3 uppercase border-b-2 border-black inline-block pb-1">
          {title}
        </h2>
        {subtitle && (
          <h3 className="text-4xl md:text-5xl font-extrabold leading-[1.1] tracking-tight text-[#1c1c1c]">
            {subtitle}
          </h3>
        )}
      </div>
      
      {description && (
        <p className="text-lg text-black/70 max-w-xl leading-relaxed font-mono">
          {description}
        </p>
      )}
      {description2 && (
        <p className="text-lg text-black/70 max-w-xl leading-relaxed font-mono">
          {description2}
        </p>
      )}
    </div>
  );

  return (
    <section id={id} className="relative w-full py-24 px-6 lg:px-16 border-t border-black/5 bg-[#f8f4f0]">
      <div className={`max-w-7xl mx-auto w-full flex flex-col lg:flex-row gap-16 items-center ${align === 'right' ? 'lg:flex-row-reverse' : ''}`}>
        
        {content}

        <div className="w-full lg:w-1/2 flex items-center justify-center">
          {children || (
            <div className="relative w-full h-[400px] bg-white rounded-xl shadow-2xl border border-black/5 flex items-center justify-center overflow-hidden">
               <div className="absolute inset-0 bg-gradient-to-br from-black/5 to-transparent" />
            </div>
          )}
        </div>

      </div>
    </section>
  );
}
